import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { Modal } from 'app/design-system/components/Modal';
import { closeSigningDialog } from 'app/modules/Signing/actions';

import ModalContent from './components/ModalContent';

const RestorePassword = (): JSX.Element => {
  const dispatch = useDispatch();

  const handleClose = useCallback(() => {
    dispatch(closeSigningDialog());
    sessionStorage.removeItem('phone');
  }, []);

  return (
    <Modal isOpen
           closable
           onClose={handleClose}
           data-test="Modal-restorePassword">
      <ModalContent />
    </Modal>
  );
};

export default RestorePassword;
